/**
 * Phase 57 Plan 57-03 — PORTAL-03
 *
 * Thin wrapper around CommentComposer for the portal reply surface.
 * Renders CommentComposer with audience='external' (no audience picker,
 * always isInternalOnly: false) inside a sticky bottom container with
 * a 120px-min textarea.
 *
 * Do NOT fork CommentComposer — reuse it directly per 57-PATTERNS.md.
 */
import { CommentComposer } from '../comments/CommentComposer';
import type { AttachmentResult } from '../../hooks/useCreateComment';

export interface ReplyComposerProps {
  taskId: number;
  projectId: number;
  /** Used to build the placeholder: "Reply to [first 40 chars]..." */
  requestTitle: string;
  /** Fired after a successful reply post so the parent can refetch comments. */
  onPosted?: (result: { attachmentResults: AttachmentResult[] }) => void;
}

export function ReplyComposer({ taskId, projectId, requestTitle, onPosted }: ReplyComposerProps) {
  const truncatedTitle = requestTitle.slice(0, 40);
  const placeholderText = `Reply to ${truncatedTitle}...`;

  return (
    <div className="sticky bottom-0 bg-white border-t border-ms-border p-4 [&_textarea]:min-h-[120px]">
      <CommentComposer
        taskId={taskId}
        projectId={projectId}
        audience="external"
        placeholder={placeholderText}
        onPosted={onPosted}
      />
    </div>
  );
}
